export const ExternalCalendarFragment = gql`
  fragment ExternalCalendarFragment on ExternalCalendar {
    id
    provider
    visibility
  }
`

export const AuthorizedExternalCalendarFragment = gql`
  fragment AuthorizedExternalCalendarFragment on AuthorizedExternalCalendar {
    remoteId
    name
    provider
  }
`
